import React, { useEffect } from 'react'
import event5 from './eventImg/event-5.webp'


const Event5 = () => {
    useEffect(() => {
        document.title = "IEC Workshop";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>3rd May 2025</h1>
<h3 className='text-center'>IEC Workshop on Advancement in Cooling Tower Design and Technology </h3>
</div>
   <div className='container' id='calanderevent'>
<img src={event5} alt='event5'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/HxgaB1QdQZI=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event5

